var last_callback = null
var cf_onloadmap = function () {
    if (typeof last_callback === 'function') {
        last_callback()
    }
}

SiteMap = {
    scriptUrl: 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&onload=cf_onloadmap',
    initialized: false,
    pointPreset: 'islands#darkGreenDotIcon',
    pointSelectedPreset: 'islands#redDotIcon',
    maps: [],
    loadMapScript: function (callback) {
        var self = this
        if (this.initialized) {
            callback()
        }
        else {
            last_callback = callback
            //document.write('<script async src="' + this.scriptUrl + '"><\/script>');
            $.getScript(this.scriptUrl, function () {
                SiteMap.initialized = true
            })

            //Close balloon after select pvz
            $(document).on('click', '.js-rate-select-btn', function () {
                var map_id = $(this).data('map-id')
                if (self.maps[map_id]) {
                    self.maps[map_id].balloon.close()
                }
            })

            //Highlight selected pvz
            $(document).on('rate-change.cf', function (e, id, map_id) {
                if (self.maps[map_id]) {
                    var cluster = self.maps[map_id].geoObjects.get(0)
                    if (cluster) {
                        cluster.getGeoObjects().forEach(function (item) {
                            if (item.properties.get('point_id') === id) {
                                item.options.set('preset', self.pointSelectedPreset)
                            }
                            else {
                                item.options.set('preset', self.pointPreset)
                            }
                        })
                    }
                }
            })
        }
    },
    createBalloonFromRate: function (item, map_id) {
        var $content = $('<div class="shopcart-balloon__content"></div>)')
        $content.append($('<div class="shopcart-balloon__name">' + item.name + '</div>'))
        $content.append($('<div class="shopcart-balloon__row shopcart-balloon__address"><span>Адрес: </span>' + item.custom_data.address + '</div>'))
        if (item.custom_data.note && item.custom_data.note.length) {
            $content.append($('<div class="shopcart-balloon__row shopcart-balloon__note">' + item.custom_data.note + '</div>'))
        }
        $content.append($('<div class="shopcart-balloon__row shopcart-balloon__work_time"><span>Время работы: </span>' + item.custom_data.work_time + '</div>'))
        $content.append(
            $('<div class="shopcart-balloon__row shopcart-balloon__est_delivery"><span>Примерная дата доставки: </span>' + item.est_delivery + '</div>'))
        var $footer = $('<div class="shopcart-balloon__footer"></div>)')
        $footer.append($('<div class="shopcart-balloon__rate"><span>' + format_price(item.rate) + '</span> ₽</div>'))
        $footer.append($('<div class="shopcart-balloon__select"><button data-map-id="' + map_id + '" data-rate_id="' + item.point_id +
            '" class="js-rate-select-btn btn">Выбрать</button></div>'))
        $content.append($footer)

        return new ymaps.GeoObject({
            geometry: {
                type: 'Point',
                coordinates: [
                    item['custom_data']['geo']['lat'],
                    item['custom_data']['geo']['lon'],
                ],
            }, properties: {
                clusterCaption: item.name,
                balloonContentBody: $content.html(),
                point_id: item.point_id,
            },
        }, {
            preset: this.pointPreset,
        })
    },
    renderDeliveryRates: function (map_id, $element, items, item_id) {
        if ($element.width() <= 0 || $element.height() <= 0) {
            //Element hidden??
            return
        }
        var self = this
        this.loadMapScript(function () {
            var state = {}
            var bounds = []
            var geoObjects = []
            for (var i in items) {
                if (!items.hasOwnProperty(i)) {
                    continue
                }
                var item = items[i]
                if (typeof item['custom_data'] === 'undefined' || typeof item['custom_data']['geo'] === 'undefined') {
                    continue
                }
                if (bounds.length) {
                    bounds[0] = [
                        Math.min(bounds[0][0], item['custom_data']['geo']['lat']),
                        Math.min(bounds[0][1], item['custom_data']['geo']['lon']),
                    ]
                    bounds[1] = [
                        Math.max(bounds[1][0], item['custom_data']['geo']['lat']),
                        Math.max(bounds[1][1], item['custom_data']['geo']['lon']),
                    ]
                }
                else {
                    bounds[0] = [item['custom_data']['geo']['lat'], item['custom_data']['geo']['lon']]
                    bounds[1] = [item['custom_data']['geo']['lat'], item['custom_data']['geo']['lon']]
                }
                item.point_id = i

                geoObjects.push(self.createBalloonFromRate(item, map_id))
            }
            if (bounds.length === 0) {
                //Empty rates, so show Moscow???
                state['center'] = [55.76, 37.64]
                state['zoom'] = 10
            }
            else if (bounds[0][0] === bounds[1][0] && bounds[0][1] === bounds[1][1]) {
                //Only one item
                state['center'] = bounds[0]
                state['zoom'] = 9
            }
            else {
                state = ymaps.util.bounds.getCenterAndZoom(
                    bounds,
                    [$element.width(), $element.height()]
                )
                if (!state.zoom) {
                    state.zoom = 9
                }
            }
            var map
            if (!self.maps[map_id]) {
                self.maps[map_id] = new ymaps.Map($element[0], {
                    center: state.center,
                    zoom: state.zoom,
                    controls: ['geolocationControl', 'searchControl', 'fullscreenControl', 'typeSelector', 'zoomControl']
                })
                map = self.maps[map_id]
            }
            else {
                map = self.maps[map_id]
                map.setCenter(state.center)
                map.setZoom(state.zoom)
            }
            var cluster = new ymaps.Clusterer({
                preset: 'islands#darkGreenClusterIcons',
            })
            cluster.add(geoObjects)
            map.geoObjects.removeAll()
            map.geoObjects.add(cluster)
            if (item_id) {
                $(document).trigger('rate-change.cf', [item_id, map_id])
            }
        })
    },
}
